module.exports = __webpack_public_path__ + "img/1272803477.59b6aeca.jpg";